import styled from 'styled-components';

export const Section = styled.section`
  height: 100vh;
  scroll-snap-align: center;
  perspective: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Center = styled.div`
  width: 1px;
  height: 1px;
  visibility: hidden;
  pointer-events: none;
`;
